<div class="pay-empty">
  <lucide-icon
    [name]="icon"
    [size]="32"
    class="pay-empty__icon">
  </lucide-icon>

  <p class="pay-empty__title">{{ title }}</p>

  <p *ngIf="subtitle" class="pay-empty__subtitle">{{ subtitle }}</p>

  <button
    *ngIf="ctaLabel"
    type="button"
    class="pay-empty__cta"
    (click)="onCta()">
    {{ ctaLabel }}
  </button>
</div>
